import { useMutation } from '@apollo/client';
import { graphql } from 'gql.tada';

const CreateEnrollmentsMutation = graphql.persisted(
  "CreateEnrollments",
  graphql(`
    mutation CreateEnrollments($input: CreateEnrollmentsInput!) {
      createEnrollments(input: $input) {
        schoolYear {
          id
          familyEnrollments {
            id
            enrollmentKind
            state
            inviteStatus
            studentCount
            isInquiry
            createdAt
            updatedAt
            family {
              id
              name
              slug
              primaryContactEmail
            }
          }
          studentEnrollments {
            id
            enrollmentKind
            state
            gradeLevel
            needsReview
            createdAt
            updatedAt
            person {
              id
              firstName
              lastName
            }
            familyEnrollment {
              id
              family {
                id
                name
                slug
              }
            }
          }
        }
        familyEnrollments {
          id
        }
        studentEnrollments {
          id
        }
        userErrors {
          message
          path
        }
      }
    }
  `)
);

export { CreateEnrollmentsMutation };

export function useCreateEnrollments() {
  return useMutation(CreateEnrollmentsMutation);
}
